// Catalogo servizi camera in stile Booking, raggruppati per categoria.
// Il modello dati salvato resta { category, name, paid }: qui definiamo solo
// il catalogo predefinito che alimenta il selettore (AmenitiesPicker) e la
// vista pubblica (RoomPublicView). L'ordine delle categorie e' significativo.

export const AMENITY_CATEGORIES = [
  {
    key: 'Popolari',
    label: 'Popolari',
    icon: 'Star',
    items: [
      'Wi-Fi', 'Aria Condizionata', 'Riscaldamento', 'TV a Schermo Piatto',
      'Minibar', 'Cassaforte', 'Asciugacapelli', 'Set Cortesia',
      'Accappatoio', 'Ciabatte',
    ],
  },
  {
    key: 'Elettronica',
    label: 'Elettronica',
    icon: 'Tv',
    items: [
      'Smart TV', 'Chromecast', 'Presa USB', 'Telefono',
      'Altoparlante Bluetooth', 'Dock Ricarica', 'iPad in Camera',
      'Radio Sveglia', 'Proiettore',
    ],
  },
  {
    key: 'Elettrodomestici',
    label: 'Elettrodomestici',
    icon: 'Coffee',
    items: [
      'Macchina Caffè', 'Bollitore', 'Microonde', 'Frigorifero', 'Tostapane',
      'Ferro da Stiro', 'Lavatrice', 'Asciugatrice', 'Lavastoviglie',
    ],
  },
  {
    key: 'Ventilazione',
    label: 'Ventilazione',
    icon: 'Wind',
    items: [
      'Aria Condizionata Split', 'Ventilatore a Soffitto', 'Ventilatore Portatile',
      'Purificatore Aria', 'Deumidificatore', 'Riscaldamento a Pavimento',
    ],
  },
  {
    key: 'Servizi',
    label: 'Servizi',
    icon: 'Bath',
    items: [
      'Vasca Idromassaggio', 'Doccia a Pioggia', 'Sauna Privata', 'Balcone',
      'Terrazza', 'Giardino Privato', 'Piscina Privata', 'Cucina Completa',
      'Angolo Cottura', 'Lavasecco', 'Servizio in Camera 24h', 'Colazione Inclusa',
      'Parcheggio Privato', 'Trasferimento Aeroporto',
    ],
  },
  {
    key: 'Caratteristiche',
    label: 'Caratteristiche',
    icon: 'Eye',
    items: [
      'Vista Mare', 'Vista Montagna', 'Vista Città', 'Vista Giardino',
      'Insonorizzata', 'Camino', 'Soppalco', 'Terrazza Panoramica',
      'Accesso Disabili', 'Pet Friendly', 'Piano Alto', 'Ingresso Indipendente',
    ],
  },
];

// Set di tutti i nomi del catalogo (per distinguere le amenity "custom").
export const CATALOG_NAMES = new Set(
  AMENITY_CATEGORIES.flatMap((c) => c.items),
);

// Ordine categorie per raggruppare in output (include "Altri" per i custom).
export const CATEGORY_ORDER = [...AMENITY_CATEGORIES.map((c) => c.key), 'Altri'];
